import { takeLatest, put } from 'redux-saga/effects';
import {
    CONTINUE_PROCESSING_USER_CURRENT_LOCATION,
    PUT_NATIVE_LAT_LONG,
} from '../actionTypes/NativeAppActionTypes';
import ClientLoggerAction from '../actions/ClientLoggerAction';

export function* getLatLong(action) {
    try {
        const { lat, long } = action.payload;
        yield put({
            type: PUT_NATIVE_LAT_LONG,
            payload: {
                lat,
                long,
            },
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Error while getting geo location from APP ', error);
        yield put(
            ClientLoggerAction.logError(
                'WEBVIEW::ERROR - Error while getting geo location from APP',
                error
            )
        );
    }
}

const NativeStoresByLatLongSaga = function* NativeStoresByLatLongSaga() {
    yield takeLatest(CONTINUE_PROCESSING_USER_CURRENT_LOCATION, getLatLong);
};
NativeStoresByLatLongSaga.sagaName = 'NativeStoresByLatLongSaga';

export default NativeStoresByLatLongSaga;
